import { render, staticRenderFns } from "./CustomizeHomepage.vue?vue&type=template&id=c4f61a58&"
import script from "./CustomizeHomepage.vue?vue&type=script&lang=js&"
export * from "./CustomizeHomepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports